import { useAuthLayoutStore } from '@/features/auth/layout/useAuthLayoutStore.js'

export function useSponsors() {
  const { sponsorLogos } = useAuthLayoutStore()

  return { sponsorLogos }
}
